export default __webpack_public_path__ + "static/media/lightmotor.2ac6e907.png";